import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';

const Breadcrumb = () => {
  const location = useLocation();
  const navigate = useNavigate();

  if (location?.pathname !== '/store-details') {
    return null;
  }

  const referrer = document.referrer;
  const fromMap = referrer?.includes('/interactive-map');
  const fromStorefronts = referrer?.includes('/main-storefronts');

  const handleBack = () => {
    if (fromMap) {
      navigate('/interactive-map');
    } else if (fromStorefronts) {
      navigate('/main-storefronts');
    } else {
      navigate('/main-storefronts');
    }
  };

  return (
    <nav className="bg-background border-b border-border py-4 mt-16 lg:mt-16">
      <div className="max-w-screen-2xl mx-auto px-6">
        <div className="flex items-center gap-2 text-sm">
          <button
            onClick={handleBack}
            className="flex items-center gap-2 text-muted-foreground hover:text-primary transition-smooth focus:outline-none focus:ring-3 focus:ring-ring focus:ring-offset-3 rounded px-2 py-1"
          >
            <Icon name="ChevronLeft" size={16} />
            <span className="hidden sm:inline">
              {fromMap ? 'Torna alla Mappa' : 'Torna alle Vetrine'}
            </span>
            <span className="sm:hidden">Indietro</span>
          </button>

          <Icon name="ChevronRight" size={16} className="text-muted-foreground" />

          <span className="text-foreground font-medium">Dettagli Attività</span>
        </div>
      </div>
    </nav>
  );
};

export default Breadcrumb;